import { AxiosInstance } from 'axios';
import { Dictionary } from 'vuex';

export enum Statuses {
  ERROR = 'error',
  READY = 'ready',
  WAITING = 'waiting',
  SENT = 'sent',
  SENDING = 'sending',
}

export interface Municipality {
  id: Id;
  name: string;
  sort: any;
}

export interface Activity {
  announce: string;
  name: string;
  conditions: string;
  contacts: string;
  cost: string;
  description: string;
  duration: string;
  educationForm: string;
  educationFormName: string;
  expectedResults: string;
  id: Id;
  imageSrc: Url;
  images: Array<ImageParams>;
  isLocked: boolean;
  level: string;
  location: string;
  materialBase: string;
  members: Array<string>;
  copMultiName: string;
  municipalityId: Id;
  partnerId: Id;
  periodStart: string;
  persons: string;
  copMulti: string;
  plan: string;
  press: string;
  results: string;
  section: string;
  state: Id;
  targets: string;
  partnerName: string;
  partnerShortName: string;
  partnerPhone: string;
  partnerEmail: string;
  qrcodeImageSrc: string;
}

export interface SheduleParams {
  startDate: string;
  endDate?: string;
}

export interface ImageParams {
  id: string;
  activity_id: string;
  big: Url;
  little: Url;
  original: Url;
  url: Url;
}

export interface ActivityExtended extends Activity {
  municipality?: Municipality;
}

export interface Params {
  id: string;
}

export interface Providers {
  $api: AxiosInstance;
  $config: Dictionary<any>;
}

export interface RootState {
  municipalities: Array<Municipality>;
  educationForms: Array<any>;
  activityMembers: Array<any>;
  activityLevels: Array<any>;
}

export interface State {
  activity: Activity;
  activities: Activities;
  status: Statuses;
}

export interface Params {
  id: Id;
}

export interface Child extends Params {
  birthday: string;
  fullName: string;
}

export interface To {
  name: string;
  params: Params;
}

export interface Links {
  title: string;
  to: To;
}

export interface ActivityChildren extends Params {
  birthday: string;
  first_name: string;
  last_name: string;
  patro_name: string;
}



export interface ITimePeriodsByDatesItem {
  calendarId: number
  endDate: string
  endTime: Date
  id: number
  interval: number | null
  manual: string
  setting_id: string
  startDate: string
  startTime: Date
  timePeriodLabel: string
  value?: number
  text?: string
}

export interface ITimePeriodsByDates {
  [key: string]: Array<ITimePeriodsByDatesItem>;
}

export type Id = string;
export type Photos = Array<string>;
export type Activities = Array<Activity>;
export type Url = string;
export type Children = Array<Child>;
export type Shedule = Array<string>;



// WEBPACK FOOTER //
// ./src/pages/activities/card/types.ts